const problems = [
  {
    id: 11,
    display: 'Delay Production',
    color: '#FF3333',
  },
  {
    id: 12,
    display: 'Delay Schedule Booking',
    color: '#FF3333',
  },
  {
    id: 13,
    display: 'Delay Loading',
    color: '#FF3333',
  },
  {
    id: 14,
    display: 'Delay Departure',
    color: '#FF3333',
  },
  {
    id: 15,
    display: 'Delay Transit Time',
    color: '#FF3333',
  },
  {
    id: 16,
    display: 'Delay Arrival',
    color: '#FF3333',
  },
  {
    id: 17,
    display: 'Delay Customs Clearance',
    color: '#FF3333',
  },
  {
    id: 18,
    display: 'Shipping Document Pending',
    color: '#FF3333',
  },
  {
    id: 20,
    display: 'Damaged Package',
    color: '#C1B79F',
  },
  {
    id: 30,
    display: 'Defect Product',
    color: '#F0E265',
  },
  {
    id: 40,
    display: 'Incorrect Product Variants',
    color: '#1CA5FF',
  },
  {
    id: 50,
    display: 'Reject',
    color: '#55BF3B',
  },
  {
    id: 60,
    display: 'Partial Shipment',
    color: '#135474',
  },
  {
    id: 70,
    display: 'Short Lead Time',
    color: '#E77D08',
  },
]

export default problems
